import * as React from 'react'
import Dropzone from 'react-dropzone'

import { Box, Text } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { Authorized } from 'modules/core/components/Authorized'
import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import filesStore from 'modules/documents/components/Documents/store'

import { FileList } from './FileList'
import FooterUploadForm from './FooterUploadForm'
import * as styles from './index.vanilla.css'

interface Props {
  onClose: () => void
  employeeId: number
}

const UploadPictureModal = ({ onClose, employeeId }: Props) => {
  const {
    company: { subscription },
  } = useCurrentSession()
  const form = React.useRef(
    new Form(
      {
        employee_id: employeeId,
      },
      {
        employee_id: 'number',
      }
    )
  ).current

  const onDrop = (files: File[]) => {
    filesStore.concat(files)
  }

  const onDeleteFile = (i: number) => {
    filesStore.files.splice(i, 1)
  }

  return (
    <Modal
      title={i18n.t('employee_form.face_recognition_info.modal_title')}
      description={i18n.t('employee_form.face_recognition_info.modal_description')}
      illustration="file-upload"
      onClose={onClose}
      footer={<FooterUploadForm form={form} close={onClose} />}
    >
      <Authorized subscription={subscription}>
        <Dropzone onDrop={onDrop} multiple={false} disabled={filesStore.files.length > 0}>
          {({ getRootProps, getInputProps, isDragActive }) => (
            <div
              {...getRootProps()}
              className={`${styles.dropzone} ${isDragActive && styles.dropzoneActive}`}
            >
              <input {...getInputProps()} />
              <div className={styles.illustrationContainer}>
                <img src={clouds} />
              </div>
              <>{i18n.t('employee_form.face_recognition_info.modal_drop_picture')}</>
            </div>
          )}
        </Dropzone>
      </Authorized>

      {filesStore.files.length > 0 && (
        <Box paddingTop="s24">
          <FileList onDeleteFile={onDeleteFile} />
        </Box>
      )}

      <Box paddingTop="s24">
        <Text.Normal size="300">
          {i18n.t('employee_form.face_recognition_info.modal_recommendations.info')}
        </Text.Normal>
        <Box gap="s16" paddingTop="s24" component="ul">
          <Box justifyContent="spaceBetween" flexDirection="row">
            <Text.Normal size="300">
              {i18n.t('employee_form.face_recognition_info.modal_recommendations.first')}
            </Text.Normal>
          </Box>
          <Box justifyContent="spaceBetween" flexDirection="row">
            <Text.Normal size="300">
              {i18n.t('employee_form.face_recognition_info.modal_recommendations.second')}
            </Text.Normal>
          </Box>
          <Box justifyContent="spaceBetween" flexDirection="row">
            <Text.Normal size="300">
              {i18n.t('employee_form.face_recognition_info.modal_recommendations.third')}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default observer(UploadPictureModal)
